export default __webpack_public_path__ + "static/media/Phoenix Browser.cdf0a3af.svg";